<!--
 * @Author: chenxing
 * @Date: 2021-03-23 10:13:20
 * @LastEditors: Yran
 * @LastEditTime: 2022-01-07 14:30:36
-->
<template>
  <div class="report_center w100 h100">
    <a-tabs v-model:activeKey="activeTabKey" @change="onTabChange" class="filter_tab min_weight40">
      <a-tab-pane key="TT" tab="巨量引擎" force-render>
        <!-- <tt /> -->
      </a-tab-pane>
      <a-tab-pane key="GDT" tab="腾讯广告" force-render>
        <!-- <gdt /> -->
      </a-tab-pane>
      <a-tab-pane key="KS" tab="磁力引擎" force-render>
        <!-- <ks /> -->
      </a-tab-pane>
      <a-tab-pane key="QC" tab="千川引擎" force-render>
        <!-- <ks /> -->
      </a-tab-pane>
      <template #tabBarExtraContent>
        <div style="display: flex; align-items: center; margin-right: 3em">
          <label>显示具体数字：</label> <a-switch v-model:checked="amountShowDetail" />
          <span class="color45" style="margin-right: 2em">数据更新时间：{{ refreshTime }}</span>
           <a-button class="ml10 mr10" :disabled="tableLoading" type="primary" @click="getAdvertiserReport">
            刷新
            <template #icon><UndoOutlined /></template>
          </a-button>
        </div>
      </template>
    </a-tabs>

    <!-- 通用条件区域 -->
    <a-form layout="horizontal" :model="filterConditions" class="filter-container">
      <a-row>
        <a-col span="6">
          <a-form-item label="日期范围" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-range-picker :placeholder="['开始日期', '结束日期']" v-model:value="defaultRange" :allow-clear="dimension !== 'timeAccumul' && dimension !== 'timeNoAccumul'" separator="到" :format="[dateRangeFormat, dateRangeFormat]" :ranges="dateRanges" :disabled-date="disabledDate" @change="onDateRangeChange" :disabled="tableLoading" />
          </a-form-item>
        </a-col>
        <a-col span="18">
          <a-form-item label="数据维度" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
            <a-radio-group button-style="solid" v-model:value="dimension" style="line-height: unset" @change="onDimensionChange" :disabled="tableLoading">
              <a-radio :value="item.value" v-for="(item, index) in dimensionOptions" :key="index">{{ item.text }}</a-radio>
              <a-tooltip placement="topLeft">
                <template #title>
                  <span>该数据维度时间维度请选择一天!</span>
                </template>
              </a-tooltip>
              <a-tooltip placement="topLeft">
                <template #title>
                  <span>该数据维度时间维度请选择一天!</span>
                </template>
              </a-tooltip>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="6">
          <a-form-item label="客户" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select class="select-tagmode" mode="multiple" label-in-value v-model:value="filterConditions.customerNames" placeholder="请选择客户" style="width: 100%" :filter-option="true" :max-tag-count="1" :allow-clear="true" :dropdown-match-select-width="false" @search="onCustomerSearch" @change="onCustomerChange" :disabled="tableLoading">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
              <a-select-option v-for="c in customerOptions" :label="c.text" :key="c.value">
                {{ c.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="6">
          <a-form-item label="产品" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select class="select-tagmode" mode="multiple" label-in-value v-model:value="filterConditions.projectIds" placeholder="请选择产品" style="width: 100%" option-filter-prop="label" :filter-option="true" :max-tag-count="1" :show-arrow="true" :allow-clear="true" :dropdown-match-select-width="false" :disabled="tableLoading" @search="onProjectSearch">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
              <a-select-option v-for="p in projectOptions" :key="p.value" :label="p.text">
                {{ p.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="6">
          <a-form-item label="部门" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-tree-select class="select-tagmode" v-model:value="filterConditions.deptId" :tree-data="departmentOptions" :replace-fields="replaceFields" placeholder="请选择部门" style="width: 100%" @change="onDepartmentChange" tree-node-filter-prop="title" :tree-default-expanded-keys="treeDefaultExpandedKeys" allow-clear show-search :disabled="tableLoading">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
            </a-tree-select>
          </a-form-item>
        </a-col>
        <a-col span="6">
          <a-form-item label="运营人员" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select class="select-tagmode" mode="multiple" label-in-value v-model:value="filterConditions.operaterIds" placeholder="请选择运营人员" style="width: 100%" option-filter-prop="label" :filter-option="true" :max-tag-count="1" :show-arrow="true" :allow-clear="true" :disabled="tableLoading">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
              <a-select-option v-for="d in operatorOptions" :key="d.value" :label="d.text">
                {{ d.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="6" v-if="activeTabKey === 'TT'">
          <a-form-item label="媒体账号" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select mode="multiple" label-in-value v-model:value="filterConditions.mdaccountIds" placeholder="请选择媒体账号" style="width: 100%" :filter-option="false" :max-tag-count="1" :show-arrow="true" :allow-clear="true" :dropdown-match-select-width="false" @search="value => onMediaAccountSearch(value, 'text')" :disabled="tableLoading">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
              <a-select-option v-for="d in mediaAccountOptions" :key="d.value" :label="d.text">
                {{ d.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="6" v-else>
          <a-form-item label="媒体账号ID" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-select mode="multiple" label-in-value v-model:value="filterConditions.mdaccountIds" placeholder="请选择媒体账号ID" style="width: 100%" :filter-option="false" :max-tag-count="1" :show-arrow="true" :allow-clear="true" :dropdown-match-select-width="false" @search="value => onMediaAccountSearch(value, 'value')" :disabled="tableLoading">
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
              <a-select-option v-for="d in mediaAccountOptions" :key="d.value" :label="d.value">
                {{ d.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="6" class="pl2em">
          <a-form-item>
            <a-space>
              <a-button type="primary" @click="doFilter" :disabled="tableLoading">筛选</a-button>
              <a-button @click="resetFilter" :disabled="tableLoading">重置筛选</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <selected-conditions v-show="conditions.length > 0" :condition-list="conditions" />
    <!-- 表格区域 -->
    <div class="table_wrapper w100">
      <datatable v-if="dimension === 'timeAccumul' || dimension === 'timeNoAccumul'" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" row-key="rowKey" :table-data="reportTabelData" :table-loading="tableLoading" :strip-show="true" :cols-setting="tableColumns" :pagination="tablePagination" :fixed-first-row="dimension !== 'timeAccumul' && dimension !== 'timeNoAccumul'" @table-change="onCustomizeTableChange">
        <template #cost="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.cost).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.cost) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.cost).toLocaleString('en-US') }}
          </template>
        </template>
        <template #viewCount="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.viewCount).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.viewCount) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.viewCount).toLocaleString('en-US') }}
          </template>
        </template>
        <template #clickCount="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.clickCount).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.clickCount) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.clickCount).toLocaleString('en-US') }}
          </template>
        </template>
      </datatable>
      <a-table v-else size="small" :data-source="reportTabelData" :columns="columns" row-key="rowKey" :pagination="tablePagination" :loading="tableLoading" bordered :scroll="{ x: 'max-content', y: tableHeight }" class="ant-table-striped ant-table-fixed-first-row" :row-class-name="(record, index) => (index1 % 2 === 1 ? 'table-striped' : null)" @change="onTableChange">
        <template #cost="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.cost).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.cost) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.cost).toLocaleString('en-US') }}
          </template>
        </template>
        <template #showNum="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.showNum).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.showNum) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.showNum).toLocaleString('en-US') }}
          </template>
        </template>
        <template #click="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.click).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.click) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.click).toLocaleString('en-US') }}
          </template>
        </template>
        <template #active="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.active).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.active) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.active).toLocaleString('en-US') }}
          </template>
        </template>
        <template #activeCost="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.activeCost).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.activeCost) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.activeCost).toLocaleString('en-US') }}
          </template>
        </template>
        <template #activePayCost="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.activePayCost).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.activePayCost) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.activePayCost).toLocaleString('en-US') }}
          </template>
        </template>
        <template #activePayRate="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.activePayRate).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.activePayRate) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.activePayRate).toLocaleString('en-US') }}
          </template>
        </template>

        <template #payOrderCount="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.payOrderCount).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.payOrderCount) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.payOrderCount).toLocaleString('en-US') }}
          </template>
        </template>

        <template #payOrderAmount="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.payOrderAmount).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.payOrderAmount) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.payOrderAmount).toLocaleString('en-US') }}
          </template>
        </template>

        <template #indirectOrderCreateCount7days="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.indirectOrderCreateCount7days).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.indirectOrderCreateCount7days) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.indirectOrderCreateCount7days).toLocaleString('en-US') }}
          </template>
        </template>

        <template #indirectOrderCreateGmv7days="{ record }">
          <template v-if="!amountShowDetail">
            <a-tooltip>
              <template #title>{{ Number(record.indirectOrderCreateGmv7days).toLocaleString('en-US') }}</template>
              {{ formatAmount(record.indirectOrderCreateGmv7days) }}
            </a-tooltip>
          </template>
          <template v-else>
            {{ Number(record.indirectOrderCreateGmv7days).toLocaleString('en-US') }}
          </template>
        </template>


      </a-table>
    </div>
  </div>

  <!-- 趋势图 -->
  <div class="jlyq_chart_wrapper trend_wrapper w100 bcg_w">
    <base-chart :chart-option="options" :show-fold="true" title="趋势图">
      <template #filter>
        <a-select label-in-value v-model:value="trendFilter.indexOneKey" @change="getTrendData" :options="selectOptions" v-bind="$filterOptions"></a-select>
        <a-select label-in-value v-model:value="trendFilter.indexTwoKey" @change="getTrendData" :options="selectOptions" v-bind="$filterOptions"></a-select>
      </template>
    </base-chart>
  </div>
</template>

<script>
/* eslint-disable */
import BaseChart from './components/BaseChart.vue';
import { UndoOutlined } from '@ant-design/icons-vue';
import { ref, reactive } from 'vue';
import { uuid } from 'vue-uuid';
import { tt, ks, gdt, qc } from './drawer';
import selectedConditions from './selectedConditions.vue';
import caliber from '@/components/Customize/caliber.vue';
import datatable from '@/components/Customize/table.vue';
import CustomizeColumn from '@/components/Customize/customizeColumnModal.vue';
import TempSelect from '@/components/Customize/templateSelect.vue';
import { getAdvertiserReportData, getMediaAccountListData, getOperatorDataByDeptId, exportExcel, getAggregation, getNoAggregation, getRefreshTime } from '@/api/report';
import { getCustomerDistinctListData } from '@/api/customer/customer.js';
import { getProjectListByCompanyName } from '@/api/base/project.js';
import { getDepartmentTreeData } from '@/api/org/account.js';
import moment from 'moment';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { addChineseUnit, getDocumentScroll } from '@/utils/utils.js';
import { Empty } from 'ant-design-vue';
import { getTempNamesList, getAllTempList, getTempNameDetail, postAddTemp, postUpdateTemp, postDeleteTemp, getTableDetail } from '@/api/customize/index.js';
import _ from "lodash";

export default {
  components: {
    BaseChart,
    tt,
    ks,
    gdt,
    qc,
    selectedConditions,
    caliber,
    datatable,
    TempSelect,
    UndoOutlined,
  },
  data() {
    return {
      selectedRowKeys: [],
      trendFilter: {
        indexOneKey: { value: 'cost', label: '消耗', key: 'cost' },
        indexTwoKey: { value: 'ctr', label: '点击率(%)', key: 'ctr' },
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
    };
  },
  provide() {
    return {
      getChannel: () => this.activeTabKey,
    };
  },
  setup() {
    const activeConfigType = 'GGBF'; // 口径
    const tableColumns = [];
    const tableHeight = ref(1920);
    // 上次刷新时间
    const refreshTime = ref(moment().format('YYYY-MM-DD hh:mm:ss'));

    // 所有配置项
    const menuList = [];
    // 已选指标项
    const selectedIndicator = [];
    // 选中的自定义列模板
    const activeTemp = null;
    // 编辑的原模板名称
    const oldTempName = null;
    // 自定义指标弹窗
    const modalVisible = false;
    // 模板列表
    const tempList = [];
    const locale = zhCN;
    const dateRangeFormat = 'YYYY-MM-DD';
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    // 替换 treeNode 中 title,value,key,children 字段
    const replaceFields = { children: 'list', title: 'name', key: 'name', value: 'deptId' };
    //默认展开的节点
    const treeDefaultExpandedKeys = [];

    const activeTabKey = ref('TT');
    const channelMap = {
      TT: '巨量引擎',
      GDT: '腾讯广告',
      KS: '磁力引擎',
      QC: '千川引擎',
    };
    const amountShowDetail = ref(false);
    const drawerVisible = ref(false);

    // table
    const tableLoading = ref(false);
    const reportTabelData = ref([]);
    const baseColumns = ref([
      { title: '总消耗(元)', dataIndex: 'cost', key: 'cost', width: 120, sorter: true, sortDirections: ['descend', 'ascend'], defaultSortOrder: 'descend', slots: { customRender: 'cost' } },
      { title: '曝光量', dataIndex: 'showNum', key: 'showNum', width: 120, sorter: true, sortDirections: ['descend', 'ascend'], slots: { customRender: 'showNum' } },
      { title: '点击量', dataIndex: 'click', key: 'click', width: 120, sorter: true, sortDirections: ['descend', 'ascend'], slots: { customRender: 'click' } },
      { title: 'APP激活总量', dataIndex: 'active', key: 'active', width: 120, sorter: true, sortDirections: ['descend', 'ascend'], slots: { customRender: 'active' } },
      { title: 'APP激活成本(元)', dataIndex: 'activeCost', key: 'activeCost', width: 130, slots: { customRender: 'activeCost' } },
      { title: '首次付费成本(元)', dataIndex: 'activePayCost', key: 'activePayCost', width: 130, slots: { customRender: 'activePayCost' } },
      { title: '首次付费率(%)', dataIndex: 'activePayRate', key: 'activePayRate', width: 130, slots: { customRender: 'activePayRate' } },
      // { title: '首日花费回报率', dataIndex: 'activePayRoi', key: 'activePayRoi', width: 120 },
    ]);
    // 头条报表数据列
    const ttColumns = ref([]);
    // 广点通报表数据列
    const gdtColumns = ref([]);
    // 快手报表数据列
    const ksColumns = ref([]);
    // 千川报表数据列
    const qcColumns = ref([]);

    let columnMap = new Map();
    columnMap.set('TT', ttColumns);
    columnMap.set('GDT', gdtColumns);
    columnMap.set('KS', ksColumns);
    columnMap.set('QC', qcColumns);
    columnMap.set('company', [{ title: '客户名称', dataIndex: 'customerOfCompanyName', key: 'customerOfCompanyName', width: 120 }]);
    columnMap.set('mdaAccount', [{ title: '媒体账号ID', dataIndex: 'advertiserId', width: 120, key: 'advertiserId' }]);
    columnMap.set('project', [{ title: '产品', dataIndex: 'projectName', width: 120, key: 'projectName' }]);
    columnMap.set('dept', [{ title: '部门', dataIndex: 'deptName', width: 120, key: 'deptName' }]);
    columnMap.set('opertor', [{ title: '运营人员', dataIndex: 'operaterName', width: 120, key: 'operaterName' }]);
    // 数据表分页
    const tablePagination = reactive({
      limit: '30',
      page: '1',
      pageSize: 31,
      showTotal: total => `总计${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['11', '21', '31', '51'],
    });
    const tableSorter = reactive({ orderType: 'cost', order: '2' });

    // 筛选条件
    const conditions = ref([
      // { name: '条件122222', value: '条件1' },
    ]);

    const dimension = ref('company');
    const dimensionText = '公司';
    const filterConditions = reactive({
      channel: activeTabKey,
      customerNames: [],
      projectIds: [],
      mdaccountIds: [],
      operaterIds: [],
      startTime: moment().format(dateRangeFormat),
      endTime: moment().format(dateRangeFormat),
    });

    const dimensionOptions = [
      { text: '客户', value: 'company' },
      { text: '产品', value: 'project' },
      { text: '部门', value: 'dept' },
      { text: '运营人员', value: 'opertor' },
      { text: '媒体账号', value: 'mdaAccount' },
    ];
    const customerOptions = ref([]);
    const customerStorage = [];
    const mediaAccountOptions = ref([]);
    const mediaAccountStorage = [];
    const projectOptions = ref([]);
    const projectStorage = [];
    const operatorOptions = ref([]);
    const operatorStorage = [];
    const departmentOptions = ref([]);

    const dateRanges = {
      昨天: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      最近三天: [moment().subtract(2, 'days'), moment()],
      本周: [moment().startOf('week'), moment.min(moment(), moment().endOf('week'))],
      最近七天: [moment().subtract(6, 'days'), moment()],
      本月: [moment().startOf('month'), moment.min(moment(), moment().endOf('month'))],
      最近三十天: [moment().subtract(29, 'days'), moment()],
      最近九十天: [moment().subtract(89, 'days'), moment()],
    };
    //禁止rangepick选择今天开始的日期
    const disabledDate = current => {
      return current && current > moment().add(1, 'days').startOf('day');
    };
    // rangepicker默认选中日期
    const defaultRange = ref([moment(), moment()]);

    // 获取条件列表数据标识
    const fetching = ref(false);
    const projectFetching = ref(false);
    const operatorFetching = ref(false);

    const excelExporting = ref(false);
    return {
      locale,
      refreshTime,
      tableHeight,
      tableColumns,
      menuList,
      selectedIndicator,
      activeTemp,
      oldTempName,
      modalVisible,
      tempList,
      simpleImage,
      activeConfigType,
      replaceFields, // 替换树属性
      treeDefaultExpandedKeys, // 默认展开的树节点
      activeTabKey, // 选中tab的key
      channelMap,
      amountShowDetail,
      drawerVisible, // 右侧抽屉弹出标志
      tableLoading,
      conditions, // 右侧抽屉已选中的筛选条件
      reportTabelData, //报表数据
      baseColumns,
      columnMap,
      tablePagination,
      tableSorter,
      dimension,
      dimensionText,
      filterConditions, // 筛选条件
      dimensionOptions, // 维度列表
      customerOptions, // 客户列表
      customerStorage,
      mediaAccountOptions, // 媒体账号列表
      mediaAccountStorage,
      projectOptions, // 产品列表
      projectStorage,
      operatorOptions, // 运营人员列表
      operatorStorage,
      departmentOptions, // 部门列表
      fetching,
      projectFetching,
      operatorFetching,
      dateRangeFormat,
      dateRanges,
      disabledDate,
      defaultRange,
      excelExporting,
    };
  },
  mounted() {
    this.getAdvertiserReport();
    this.getCustomerList();
    this.getProjectList();
    this.getMediaAccountList();
    this.getOperatorList();
    this.getDepartmentTree();
    this.getTempNamesList();
    // this.getAllTempList();
    // this.getTempName('默认指标');
    // this.getDepartmentList();
    window.onresize = () => {
      return (() => {
        this.tableHeight = getDocumentScroll();
      })();
    };
  },
  computed: {
    columns() {
      let res = [...this.columnMap.get(this.activeTabKey).value, ...this.columnMap.get(this.dimension), ...this.baseColumns];
      if (this.activeTabKey === 'TT' && this.dimension === 'mdaAccount') {
        res.splice(1, 0, { title: '媒体账号', dataIndex: 'advertiserName', key: 'advertiserName', width: 250 });
      }

      if (this.activeTabKey === 'QC') {
        res.splice(4, 1, { title: '直接成交订单数', dataIndex: 'payOrderCount', key: 'payOrderCount', width: 120 });
        res.splice(5, 1, { title: '直接成交金额', dataIndex: 'payOrderAmount', key: 'payOrderAmount', width: 130 });
        res.splice(6, 1, { title: '间接下单订单数', dataIndex: 'indirectOrderCreateCount7days', key: 'indirectOrderCreateCount7days', width: 130 });
        res.splice(7, 1, { title: '间接下单金额', dataIndex: 'indirectOrderCreateGmv7days', key: 'indirectOrderCreateGmv7days', width: 130 });
      }
      return res;
    },
    timeChange() {
      let days = this.defaultRange[0] && this.defaultRange[1] && this.defaultRange[1].diff(this.defaultRange[0], 'days');
      return days !== 0;
    },
  },

  methods: {
    /** 获取上次刷新时间
     * @param {*}
     * @return {*}
     */
    getRefreshTime() {
      getRefreshTime('SJ_CENTER').then(res => {
        this.refreshTime = res.list;
      });
    },
    async getCustomerList() {
      let res = await getCustomerDistinctListData({});
      this.customerStorage = res.page?.list?.map(item => ({
        text: item.customerOfCompanyName,
        value: item.customerOfCompanyName,
      }));
      this.customerOptions = this.customerStorage.slice(0, 100);
    },
    async getProjectList() {
      this.projectFetching = true;
      let res = await getProjectListByCompanyName({
        companyNames: [],
        channelType: this.activeTabKey,
      });

      this.projectStorage = res.page?.list?.map(item => ({
        text: item.projectName,
        value: item.projectCode,
        companyName: item.companyName,
      }));
      this.projectOptions = this.projectStorage.slice(0, 300);
      this.projectFetching = false;
    },
    // async getDepartmentList() {
    //   let res = await getDepartmentData({});
    //   res.deptList.forEach(item => {
    //     this.departmentOptions.push({
    //       text: item.name,
    //       value: item.deptId.toString(),
    //     });
    //   });
    // },
    // 获取部门树形数据
    async getDepartmentTree() {
      let res = await getDepartmentTreeData();
      if (res.code === 0) {
        this.departmentOptions = [res.sysDeptEntity];
        this.treeDefaultExpandedKeys = [res.sysDeptEntity.name];
      }
    },
    async getMediaAccountList() {
      //参数值转换 TT->'巨量引擎'
      if (this.activeTabKey !== 'KS') {
        let res = await getMediaAccountListData({ channelType: this.activeTabKey });
        this.mediaAccountStorage = res.page.list.map(item => ({
          text: item.advertiserName,
          value: item.advertiserId,
        }));
        this.mediaAccountOptions = this.mediaAccountStorage.slice(0, 100);
      }
    },
    async getOperatorList() {
      this.operatorFetching = true;
      let res = await getOperatorDataByDeptId({
        jobs: 'OPERATION',
        deptId: this.filterConditions.deptId,
      });

      this.operatorStorage = res.page.list.map(item => ({
        text: item.userCode,
        value: item.userId,
        deptId: item.deptId,
      }));
      this.operatorOptions = this.operatorStorage;
      this.operatorFetching = false;
    },
    async getAdvertiserReport() {
      if (this.tableLoading === true) {
        return;
      }
      this.tableLoading = true;
      let postData = {
        channel: this.activeTabKey,
        dimension: this.dimension,
        customerNames: [],
        projectIds: [],
        operaterIds: [],
        deptId: this.filterConditions.deptId,
        mdaccountIds: [],
        startTime: this.filterConditions.startTime,
        endTime: this.filterConditions.endTime,
        ...this.tablePagination,
        ...this.tableSorter,
      };

      this.filterConditions.customerNames.forEach(cus => {
        postData.customerNames.push(cus.value);
      });
      this.filterConditions.projectIds.forEach(proj => {
        postData.projectIds.push(proj.value);
      });
      this.filterConditions.operaterIds.forEach(op => {
        postData.operaterIds.push(op.value);
      });
      this.filterConditions.mdaccountIds.forEach(mda => {
        postData.mdaccountIds.push(mda.value);
      });
      let res;
      try {
        if (this.dimension !== 'timeAccumul' && this.dimension !== 'timeNoAccumul') {
          res = await getAdvertiserReportData(postData);
          this.tablePagination = {
            limit: res.page && (res.page.pageSize - 1).toString(),
            page: (res.page && res.page.currPage) + '',
            total: res.page && res.page.totalCount,
            showTotal: total => `总计${total}条数据`,
            pageSize: res.page.pageSize,
            showSizeChanger: true,
            pageSizeOptions: ['11', '21', '31', '51'],
          };
          this.tableColumns = [];
          if (res.code === 0) {
            this.reportTabelData = res.page.list;
            this.tablePagination.current = res.page.currPage;
            this.tablePagination.total = res.page.totalCount;
          }
        } else {
          res = this.dimension === 'timeAccumul' ? await getAggregation(postData) : await getNoAggregation(postData);
          this.tablePagination = {
            limit: this.tablePagination.pageSize && (this.tablePagination.pageSize - 1).toString(),
            page: this.tablePagination.page + '',
            total: res.records.length,
            pageSize: 24,
            showTotal: total => `总计${total}条数据`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '24'],
          };
          this.reportTabelData = res.records;
          this.tableColumns = [
            {
              title: '小时',
              dataIndex: 'hour',
              key: 'hour',
              width: 60,
              fixed: 'left',
            },
            {
              title: '花费',
              dataIndex: 'cost',
              key: 'cost',
              width: 100,
              slots: { customRender: 'cost' },
            },
            {
              title: '曝光量',
              dataIndex: 'viewCount',
              key: 'viewCount',
              width: 100,
              slots: { customRender: 'viewCount' },
            },
            {
              title: '点击量',
              dataIndex: 'clickCount',
              slots: { customRender: 'clickCount' },

              key: 'clickCount',
              align: 'center',
              width: 100,
            },
            {
              title: '点击率',
              dataIndex: 'clickRate',
              key: 'clickRate',
              width: 100,
            },
            {
              title: 'cpc',
              dataIndex: 'cpc',
              key: 'cpc',
              width: 80,
            },
            {
              title: 'cpm',
              dataIndex: 'cpm',
              key: 'cpm',
              width: 80,
            },
            // {
            //   title: '首日花费回报率',
            //   dataIndex: 'cheoutFdReward',
            //   key: 'cheoutFdReward',
            //   width: 80,
            // },
            {
              title: 'APP下载完成量',
              dataIndex: 'appDownloadCount',
              key: 'appDownloadCount',
              width: 120,
            },
            {
              title: 'APP下载率',
              dataIndex: 'appDownloadRate',
              key: 'appDownloadRate',
              width: 100,
            },
            {
              title: 'APP激活总量',
              dataIndex: 'appActivatedCount',
              key: 'appActivatedCount',
              width: 100,
            },
            {
              title: 'APP点击激活率',
              dataIndex: 'appActivatedRate',
              key: 'appActivatedRate',
              width: 120,
            },
            {
              title: 'APP激活成本',
              dataIndex: 'appActivatedCost',
              key: 'appActivatedCost',
              width: 120,
            },
            {
              title: '首次付费行为人数',
              dataIndex: 'firstPayCount',
              key: 'firstPayCount',
              width: 140,
            },
            {
              title: '首日付费金额',
              dataIndex: 'cheoutFd',
              key: 'cheoutFd',
              width: 120,
            },
            {
              title: '首次付费行为率',
              dataIndex: 'firstPayRate',
              key: 'firstPayRate',
            },
            {
              title: '直接成交订单数',
              dataIndex: 'payOrderCount',
              key: 'payOrderCount',
            },
            {
              title: '直接成交金额',
              dataIndex: 'payOrderAmount',
              key: 'payOrderAmount',
            },
            {
              title: '间接下单订单数',
              dataIndex: 'indirectOrderCreateCount7days',
              key: 'indirectOrderCreateCount7days',
            },
            {
              title: '间接下单金额',
              dataIndex: 'indirectOrderCreateGmv7days',
              key: 'indirectOrderCreateGmv7days',
            },
          ];
        }
      } catch (error) {
        this.tableLoading = false;
      }

      this.reportTabelData.map(item => {
        item.rowKey = uuid.v1();
      });
      this.getRefreshTime();
      this.tableLoading = false;
      this.tableHeight = getDocumentScroll();
    },
    showDrawer() {
      this.drawerVisible = true;
    },
    onCloseDrawer() {
      this.getAdvertiserReport();
      this.closeDrawer();
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
    //切换渠道
    onTabChange(key) {
      if ((this.dimension === 'timeAccumul' || this.dimension === 'timeNoAccumul') && this.activeTabKey !== 'GDT') {
        this.dimension = this.dimensionOptions[0].value;
      }
      //清空表格数据
      this.reportTabelData = [];
      //清空筛选条件
      this.conditions = [];
      //客户跟媒体账号跟渠道相关
      this.getMediaAccountList();
      // this.getCustomerList();
      // this.getProjectList();
      this.resetFilter();
    },
    // 切换统计维度
    onDimensionChange(e) {
      this.dimension = e.target.value;
      if (e.target.value !== 'timeAccumul' && e.target.value !== 'timeNoAccumul') {
        this.dimensionText = this.dimensionOptions.find(d => d.value === this.dimension).text;
      } else {
        this.dimensionText = '分时段累计';
      }
      this.tablePagination.current = 1;
      this.tablePagination.page = '1';
      this.getAdvertiserReport();
    },
    filterOptions(options, val, type) {
      return options
        .filter(op => {
          let item = op[type] + '';
          return item.indexOf(val.trim()) > -1;
        })
        .slice(0, 100);
    },
    onCustomerSearch(val) {
      let _this = this;
      if (!this.timer) {
        this.timer = setTimeout(function () {
          _this.customerOptions = _this.filterOptions(_this.customerStorage, val, 'text');
          _this.timer = null;
        }, 100);
      }
    },
    onProjectSearch(val) {
      let _this = this;
      if (!this.timer) {
        this.timer = setTimeout(function () {
          _this.projectOptions = _this.filterOptions(_this.projectStorage, val, 'text');
          _this.timer = null;
        }, 100);
      }
    },
    onCustomerChange(val, options) {
      if (options.length > 0) {
        let tempArr = [];
        options.forEach(option => {
          tempArr = tempArr.concat(
            this.projectStorage.filter(proj => {
              return proj.companyName == option.value;
            })
          );
        });

        this.projectOptions = tempArr;
      } else {
        this.filterConditions.projectIds = [];
        this.$nextTick(() => {
          this.projectOptions = this.projectStorage.slice(0, 300);
        });
      }
    },
    onDepartmentChange(val, options) {
      this.filterConditions.deptId = val && val.toString();
      // if (options.length > 0) {
      //   let tempArr = [];
      //   options.forEach(option => {
      //     tempArr = tempArr.concat(
      //       this.operatorStorage.filter(op => {
      //         return op.deptId == option.value;
      //       })
      //     );
      //   });

      //   this.operatorOptions = tempArr;
      // } else {
      //   this.filterConditions.operaterIds = [];
      //   this.operatorOptions = this.operatorStorage;
      // }
      this.getOperatorList();
    },
    onMediaAccountSearch(val, type) {
      let _this = this;
      if (!_this.timer) {
        _this.timer = setTimeout(function () {
          _this.mediaAccountOptions = _this.filterOptions(_this.mediaAccountStorage, val, type);
          _this.timer = null;
        }, 100);
      }
    },
    // 开始时间结束时间选择
    onDateRangeChange(val, dateString) {
      this.filterConditions.startTime = dateString[0];
      this.filterConditions.endTime = dateString[1];
      this.tablePagination.page = '1';
      this.getAdvertiserReport();
    },
    onCustomizeTableChange(pagination) {
      this.tablePagination.pageSize = pagination.pageSize;
      this.tablePagination.limit = pagination.limit;
      this.tablePagination.page = pagination.page;
    },
    // 表格翻页
    onTableChange(pagination, filters, sorter) {
      this.tablePagination.page = pagination.current.toString();
      this.tablePagination.limit = (pagination.pageSize - 1).toString();
      this.tablePagination.pageSize = pagination.pageSize;
      this.tableSorter.orderType = sorter.field;
      this.tableSorter.order = sorter.order == 'ascend' ? '1' : '2';
      this.getAdvertiserReport();
    },
    // 筛选数据
    doFilter() {
      this.tablePagination.current = 1;
      this.tablePagination.page = '1';
      this.getAdvertiserReport();
    },
    doSyncData() {
      this.getAdvertiserReport();
    },
    resetFilter() {
      this.filterConditions.channel = this.activeTabKey;
      this.filterConditions.customerNames = [];
      this.filterConditions.projectIds = [];
      this.filterConditions.deptId = null;
      this.filterConditions.mdaccountIds = [];
      this.filterConditions.operaterIds = [];

      this.tablePagination.current = 1;
      this.tablePagination.page = '1';
      this.getAdvertiserReport();
    },
    formatAmount(val) {
      if (val === 0) {
        val = '';
      }
      return addChineseUnit(val);
    },
    async onExportExcelBtnClick() {
      this.excelExporting = true;
      let postData = {
        channel: this.activeTabKey,
        dimension: this.dimension,
        customerNames: [],
        projectIds: [],
        operaterIds: [],
        deptId: this.filterConditions.deptId,
        mdaccountIds: [],
        startTime: this.filterConditions.startTime,
        endTime: this.filterConditions.endTime,
        ...this.tablePagination,
        ...this.tableSorter,
      };
      this.filterConditions.customerNames.forEach(cus => {
        postData.customerNames.push(cus.label.children);
      });
      this.filterConditions.projectIds.forEach(proj => {
        postData.projectIds.push(proj.value);
      });
      this.filterConditions.operaterIds.forEach(op => {
        postData.operaterIds.push(op.value);
      });
      this.filterConditions.mdaccountIds.forEach(mda => {
        postData.mdaccountIds.push(mda.value);
      });

      let res = await exportExcel(postData);
      // application/vnd.ms-excel是转换的文件格式
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      let objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = `${this.channelMap[this.activeTabKey]}-${this.dimensionText}`;
      if (this.filterConditions.startTime) link.download += `-${this.filterConditions.startTime}`;
      if (this.filterConditions.endTime) link.download += `至${this.filterConditions.endTime}`;
      link.download += '.xlsx';
      link.click();
      URL.revokeObjectURL(objectUrl);
      this.excelExporting = false;
    },
    /** 口径下拉变化
     * @param {*}
     * @return {*}
     */
/*    onTJKJSelect(item) {
      this.activeConfigType = item;
      this.getTempNamesList();
      this.getAllTempList();
      this.activeTemp = '默认指标';
      // this.getTableData();
    },*/
    /** 获取自定义指标菜单列表-数据中心所有指标
     * @param {*}
     * @return {*}
     */
    async getTempNamesList() {
      let res = await getTempNamesList();
      this.menuList = res.list;
    },
    /** 获取素材库所有指标
     * @param {*}
     * @return {*}
     */
    async getAllTemp() {
      let res = await getAllTemp();
      res.list?.forEach(item => {
        item.info?.forEach(childItem => {
          childItem.customConfigId = childItem.id;
          childItem.info?.forEach(info => {
            info.customConfigId = info.id;
          });
        });
      });
      this.menuList = res.list;
      this.menuListSource = _.cloneDeep(res.list);
      this.mediaChannelChange(this.filterCondition.mediaChannelList);
    },
    /** 获取所有自定义模板
     * @param {*}
     * @return {*}
     */
    getAllTempList() {
      getAllTempList(this.activeTabKey, 'GDT').then(res => {
        this.tempList = res.list;
      });
    },
    /** 获取排序后的已选指标数组
     * @param {Array} list 已选指标数组
     * @return {*}
     */
    getDraggableList(list) {
      this.selectedIndicator = list;
    },
    deleteTemp(tempName) {
      this.operatType = 'delete';
      postDeleteTemp([tempName]).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功');
          this.getAllTempList();
        }
      });
    },
    /** 获取表格详情
     * @param {Object} postParams 筛选参数
     * @return {*}
     */
    getTableDetail(postParams) {
      let postData = {
        configKey: this.activeTabKey,
        mediaChannel: 'GDT',
        tempName: this.activeTemp,
        moduleName: '媒体账户',
        page: '1',
        limit: '10',
        ...postParams,
      };
      getTableDetail(postData).then(res => {
        this.tableData = res.page && res.page.records;
      });
    },
    onSelectChange(selectKeys, selectedRows) {
      this.selectedRowKeys = selectKeys;
    },
  },
};
</script>
<style lang="less" scoped>
.report_center {
  display: flex;
  flex-direction: column;
}
.filter_tab {
  margin-top: -16px;
  background: #fff;
  margin-top: 0;
  border-radius: 8px 8px 0 0;
}
.filter-container {
  :deep(.ant-form-item-label) {
    line-height: 40px;
  }
}

.ant-table-striped :deep(.table-striped) {
  background-color: #fafafa;
}
.ant-table-fixed-first-row :deep(table) tbody tr:nth-child(1) td {
  background: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
}
.min_weight40{
  min-height: 30px;
}
</style>
<style lang="less">
.select-tagmode {
  .ant-select-selector {
    flex-wrap: nowrap;
    .ant-select-selection-item {
      flex: 0 1 auto;
      min-width: 4em;
    }
  }
}
</style>